import React from 'react';
import { observer } from 'mobx-react-lite';
import { useAppStateContext } from 'src/AppState/AppState';
import { QuickLinkTraySelect } from '../QuickLinkTraySelect/QuickLinkTraySelect';
import { OldInput } from 'src/domains/layouts/shared/formComponents/input/OldInput';
import { ErrorMessageBar } from 'src/domains/layouts/shared/formComponents/FormComponents.style';

export const QuickLinkTrayRedirectOptions = observer((): React.ReactElement | null => {
    const { cmsState } = useAppStateContext();
    const { quickLinkTrayState } = cmsState;
    const {
        directUrlStatus, directUrl, directUrlModel,
        eventIdStatus, eventId, eventIdModel,
        competitionIdStatus, competitionId, competitionIdModel,
        casinoGameIdStatus, casinoGameId, casinoGameIdModel,
        redirectOption,
        competitionSport,
        sport,
        sportListOptions,
        setDefaultLabel
    } = quickLinkTrayState;
    return (
        <>
            {redirectOption.value === 'direct-link' ? (
                <OldInput
                    label='Destination link'
                    status={directUrlStatus}
                    formInputState={directUrl}
                    model={directUrlModel} />
            ) : null}
            {redirectOption.value === 'event-id' ? (
                <OldInput
                    label='Event id'
                    status={eventIdStatus}
                    formInputState={eventId}
                    model={eventIdModel} />
            ) : null}
            {redirectOption.value === 'competition-id' ? (
                <>
                    <OldInput
                        label='Competition id'
                        status={competitionIdStatus}
                        formInputState={competitionId}
                        model={competitionIdModel} />

                    <QuickLinkTraySelect selectOptions={sportListOptions} stateValue={sport} onChangeCB={setDefaultLabel} />

                    {competitionSport.errorMessage !== null ? (
                        <ErrorMessageBar>{competitionSport.errorMessage}</ErrorMessageBar>
                    ) : null}
                </>
            ) : null}
            {redirectOption.value === 'casino-game-id' ? (
                <OldInput
                    label='Casino game id'
                    status={casinoGameIdStatus}
                    formInputState={casinoGameId}
                    model={casinoGameIdModel} />
            ) : null}
            {redirectOption.value === 'sport' ? (
                <QuickLinkTraySelect selectOptions={sportListOptions} stateValue={sport} onChangeCB={setDefaultLabel} dataTest='select-sport'/>
            ) : null}
        </>
    );
});
